module.exports = __webpack_public_path__ + "static/media/exit.8d9bd1f8.ico";